import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import roleDataService from "services/role";

export const getRoles = createAsyncThunk(
  "roles/getRoles",
  async ({
    company,
    organization,
    individual,
    corporate,
    employee,
    status,
  }) => {
    const res = await roleDataService.getAll(
      company,
      organization,
      individual,
      corporate,
      employee,
      status
    );
    return res.data;
  }
);

export const createRole = createAsyncThunk(
  "roles/createRole",
  async ({ data }) => {
    const res = await roleDataService.create(data);
    return res.data;
  }
);

export const editRole = createAsyncThunk(
  "roles/update",
  async ({ roleId, data }) => {
    const res = await roleDataService.update(roleId, data);
    return res.data;
  }
);

const initialState = {
  roles: [],
  role: null,
  getRolesStatus: {
    status: "idle",
    error: false,
  },
};

const roles = createSlice({
  name: "roles",
  initialState,
  reducers: {
    updateRoleState: (state, action) => {
      state.role = action.payload.role;
    },
    resetRoleSlice: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createRole.fulfilled, (state, action) => {
        state.role = action.payload.role;
      })
      .addCase(editRole.fulfilled, (state, action) => {
        state.role = action.payload.role;
      })
      .addCase(getRoles.pending, (state) => {
        state.getRolesStatus.status = "loading";
        state.getRolesStatus.error = false;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.getRolesStatus.status = "idle";
        state.getRolesStatus.error = false;
        state.roles = action.payload.items;
      })
      .addCase(getRoles.rejected, (state, action) => {
        state.getRolesStatus.status = "failed";
        state.getRolesStatus.error = action.payload?.messageText;
      });
  },
});

export const { updateRoleState, resetRoleSlice } = roles.actions;

const { reducer } = roles;

export default reducer;
